import { render } from "./AddExtraTimeToBooking.vue?vue&type=template&id=55218442"
import script from "./AddExtraTimeToBooking.vue?vue&type=script&lang=js"
export * from "./AddExtraTimeToBooking.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src429286328/src/application/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__